import { ComponentPropsWithoutRef } from 'react';
import clsx from 'clsx';

/**
 * Configuration properties for the Heading components.
 */
type HeadingProps = {
  /** The semantic level of the heading (h1-h6). */
  level?: 1 | 2 | 3 | 4 | 5 | 6;
} & ComponentPropsWithoutRef<'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'>;

/**
 * A standard heading component.
 */
export function Heading({ className, level = 1, ...props }: HeadingProps) {
  const Element: `h${typeof level}` = `h${level}`;

  return (
    <Element
      {...props}
      className={clsx(
        className,
        'text-2xl/8 font-semibold text-gray-950 sm:text-xl/8 dark:text-white'
      )}
    />
  );
}

/**
 * A smaller subheading component.
 */
export function Subheading({ className, level = 2, ...props }: HeadingProps) {
  const Element: `h${typeof level}` = `h${level}`;

  return (
    <Element
      {...props}
      className={clsx(
        className,
        'text-base/7 font-semibold text-gray-950 sm:text-sm/6 dark:text-white'
      )}
    />
  );
}
